<template>
	<div id="ratings">
		<div class="container">
		  <div class="swiper">
		  	<swiper :options="swiperOption">
				<swiper-slide v-for="(item,index) in info.images" :key="index"><img :src="item" class="swiper-img"></swiper-slide>
			</swiper>
		  </div>
		  <div class="top"> 
			<div class="title">{{info.subject}}</div>
			<div class="flexbox">
			  <div class="flex1 price">
				￥<span>{{info.price}}</span>
			  </div>
			  <div class="flex1 count">
				最近销售：{{info.selled}}件
			  </div>
			</div>
		  </div>
		  <div class="content" style="margin-bottom:20px;">
			<div class="title">简介</div>
			<div class="con" v-html="info.content"></div>
		  </div>
		  <div class="buttom">
			<router-link to="/ratingsform"><div class="btn" bindtap="event_submit">立即支付</div></router-link>
		  </div>
		</div>
	</div>
</template>

<script>
let parent_route = ''
export default {
	name: 'Ratings',
	data () {
		return {
			info:[],
			swiperOption:{
				slidesPerView: 'auto',
				centeredSlides:true,
				spaceBetween: 10,
				loop:true,
				speed:600, //config参数同swiper4,与官网一致
				autoplay:true,
				height:'50vw'
			}
		}
	},
	beforeRouteEnter (to, from, next) {
		parent_route = from.name
		next(vm => {})
	},
	activated(){
		var that = this
		if(parent_route == 'Ratingsform'){
			this.$app.pr("/api/pay/lnsurance", {
			    id: this.info.id,
			    params: JSON.stringify(this.$store.state.insuranceParams)
			}).then(function(o) {
				that.$wx.requestPayment(o).then((res) =>{
					this.$router.push({path:'/payresult',query:{
						order_sn:o.data.order_sn
					}});
				}).catch((res) => {
					this.$router.push({path:'/payresult',query:{
						order_sn:o.data.order_sn
					}});
				});
			}).catch(function(a) {
			    that.$wx.showToast({
				title: "支付失败，请重试"
			    });
			})
		}else{
			this.$store.state.insuranceParams = null;
		}
	},
	created (){
		this.$https.post('/api/lnsurance/detail',this.$qs.stringify({
			token:this.$store.state.token
		})).then((res) => {
			this.info = res.data.data
			console.log(res.data.data);
		}).catch((res) => {
			console.log('请求失败')
		})

	},
	methods:{
		
	}
}
</script>
<style scoped>
	#ratings{
		background-color:#FFFFFF;
		min-height:100vh;
	}
	.swiper{
	  height:50vw;
	}
	.swiper img{
	  width:100%;
	  height:50vw;
	}
	.top{
	  background-color:#FFFFFF;
	  padding:0px 3vw;
	  border-top:1px solid #DDDDDD;
	  box-shadow:0px 0px 10px #CCCCCC;
	}
	.top .title{
	  line-height:10.5vw;
	  font-size:4.7vw;
	  font-weight:600;
	  color:#313131;
	}
	.flexbox{
	  display:flex;
	  line-height:7.9vw;
	  font-size:4.2vw;
	  color:#a9a9a9;
	  padding-bottom:10px;
	}
	.flex1{
	  flex:1;
	}
	.flexbox .price{
	  color:#ff6201;
	}
	.flexbox .price text{
	  font-size:5.2vw;
	}
	.flexbox .count{
	  text-align:right;
	}
	.content{
	  margin-top:10px;
	  background-color:#FFFFFF;
	  padding:3vw;
	}
	.content .title{
	  height:8vw;
	  border-bottom:1px solid #EEEEEE;
	  font-size:4.2vw;
	  color:#434343;
	}
	.content .con{
	  padding-top:3vw;
	  font-size:4.2vw;
	}
	.content .con image{
	  max-width:100%;
	  color:#434343;
	}
	.buttom{
	  position:fixed;
	  bottom:50px;
	  width:100%;
	  height:13vw;
	  background-color:#FFFFFF;
	  box-shadow: -6px 0px 6px #DDDDDD;
	}
	.buttom .btn{
	  height:10vw;
	  width:30vw;
	  line-height:10vw;
	  color:#FFFFFF;
	  font-size:4.2vw;
	  background-color:#2cd5ff;
	  border-radius:5px;
	  margin-top:5px;
	  float:right;
	  margin-right:3vw;
	  text-align:center;
	}
</style>


// WEBPACK FOOTER //
// src/components/Ratings.vue